export const styles = (theme) => ({
  root: {
    width: '100%',
    height: '100%',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.08)',
    borderRadius: 30,
    padding: theme.spacing(2),
    position: 'relative',
    bottom: 0,
    transition: 'bottom .3s',
    '&:hover': {
      bottom: theme.spacing(0.5),
    },
  },

  cardContent: {
    height: '100%',
    position: 'relative',
  },

  cardTitle: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    color: '#494949',
  },

  cardCategoriaEstabelecimento: {
    color: theme.palette.primary.main,
    fontFamily: 'Poppins',
    fontWeight: 600,
  },

  cardAtendendoComo: {
    fontFamily: 'Poppins',
    fontWeight: 600,
  },

  cardAdress: {
    fontWeight: 500,
    color: '#494949',
  },

  primary: {
    color: theme.palette.primary.main,
  },

  secondary: {
    color: theme.palette.secondary.main,
  },

  seeMore: {
    cursor: 'pointer',
    fontWeight: 'bold',
    marginTop: theme.spacing(2),
    fontFamily: 'Poppins',
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
})
